// source: pbtypes/vehicle/complimentary_actions/trigger_args.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.complimentary_actions.TriggerArgs', null, global);
goog.exportSymbol('proto.complimentary_actions.TriggerArgs.ChannelCallback', null, global);
goog.exportSymbol('proto.complimentary_actions.TriggerArgs.ChannelCallback.Channel', null, global);
goog.exportSymbol('proto.complimentary_actions.TriggerArgs.TimerCallback', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.TriggerArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.complimentary_actions.TriggerArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.TriggerArgs.displayName = 'proto.complimentary_actions.TriggerArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.TriggerArgs.TimerCallback = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.complimentary_actions.TriggerArgs.TimerCallback, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.TriggerArgs.TimerCallback.displayName = 'proto.complimentary_actions.TriggerArgs.TimerCallback';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.complimentary_actions.TriggerArgs.ChannelCallback, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.TriggerArgs.ChannelCallback.displayName = 'proto.complimentary_actions.TriggerArgs.ChannelCallback';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.TriggerArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.TriggerArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.TriggerArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.TriggerArgs.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.TriggerArgs}
 */
proto.complimentary_actions.TriggerArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.TriggerArgs;
  return proto.complimentary_actions.TriggerArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.TriggerArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.TriggerArgs}
 */
proto.complimentary_actions.TriggerArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.TriggerArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.TriggerArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.TriggerArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.TriggerArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.TriggerArgs.TimerCallback.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.TriggerArgs.TimerCallback.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.TriggerArgs.TimerCallback} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.TriggerArgs.TimerCallback.toObject = function(includeInstance, msg) {
  var f, obj = {
dt: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.TriggerArgs.TimerCallback}
 */
proto.complimentary_actions.TriggerArgs.TimerCallback.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.TriggerArgs.TimerCallback;
  return proto.complimentary_actions.TriggerArgs.TimerCallback.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.TriggerArgs.TimerCallback} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.TriggerArgs.TimerCallback}
 */
proto.complimentary_actions.TriggerArgs.TimerCallback.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.TriggerArgs.TimerCallback.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.TriggerArgs.TimerCallback.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.TriggerArgs.TimerCallback} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.TriggerArgs.TimerCallback.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDt();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
};


/**
 * optional float dt = 1;
 * @return {number}
 */
proto.complimentary_actions.TriggerArgs.TimerCallback.prototype.getDt = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.TriggerArgs.TimerCallback} returns this
 */
proto.complimentary_actions.TriggerArgs.TimerCallback.prototype.setDt = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.TriggerArgs.ChannelCallback.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.TriggerArgs.ChannelCallback} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback.toObject = function(includeInstance, msg) {
  var f, obj = {
channel: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.TriggerArgs.ChannelCallback}
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.TriggerArgs.ChannelCallback;
  return proto.complimentary_actions.TriggerArgs.ChannelCallback.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.TriggerArgs.ChannelCallback} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.TriggerArgs.ChannelCallback}
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.complimentary_actions.TriggerArgs.ChannelCallback.Channel} */ (reader.readEnum());
      msg.setChannel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.TriggerArgs.ChannelCallback.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.TriggerArgs.ChannelCallback} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback.Channel = {
  INVALID: 0,
  VEHICLE_POSE: 1,
  GO_TO_WAYPOINT_STATUS_PB: 2,
  MISSION_ACTION_EVENT_PB: 3,
  USER_CAMERA_PHOTO_CAPTURE: 4,
  MOTION_PLANNER_STATUS: 5
};

/**
 * optional Channel channel = 1;
 * @return {!proto.complimentary_actions.TriggerArgs.ChannelCallback.Channel}
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback.prototype.getChannel = function() {
  return /** @type {!proto.complimentary_actions.TriggerArgs.ChannelCallback.Channel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.complimentary_actions.TriggerArgs.ChannelCallback.Channel} value
 * @return {!proto.complimentary_actions.TriggerArgs.ChannelCallback} returns this
 */
proto.complimentary_actions.TriggerArgs.ChannelCallback.prototype.setChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


goog.object.extend(exports, proto.complimentary_actions);
